import { ProjectType } from 'providence-types';
import { RadioButtonProps } from '@shared/modules/ui-kit/models/interfaces';

export const LTE_NSB_RADIO_BUTTON_GROUP: RadioButtonProps[] = [
  { viewValue: ProjectType.LTE, value: ProjectType.LTE },
  { viewValue: ProjectType.NSB, value: ProjectType.NSB },
];
